import { Gauge } from '@mui/x-charts/Gauge';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

export default function GaugeBase({ title, value, max, color }) {
  const percentage = Math.round((value / max) * 100);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '1.25rem' }}>{title}</Typography>
      <Tooltip
        title={`Total: ${value}`}
        placement='right'
        arrow
      >
        <Box component='div'>
          <Gauge
            width={200}
            height={200}
            value={value}
            valueMax={max}
            text={() => `${percentage}%`}
            sx={{
              '& .MuiGauge-valueArc': {
                fill: color,
              },
              '& .MuiGauge-valueText': {
                fontSize: '1.25rem',
              },
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
}
